'use strict'

import axios from 'axios'
import allFu from '../global/global'
import {
  Notification,
  MessageBox
} from 'element-ui' //使用elementui的提示显示
import {
  Loading
} from 'element-ui'
import router from "../router";
import base from './baseUrl'
import store from "../store";
import isMobile from './crmGoBaseurl' // 跳转到对应的项目后台
import {
  returnGoUrl
} from '../global/index'
let loading
let showOut = false;
let multiDevice = false;
let showPower = false;

// 本地写死数据
let authorization = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NTM1NjIxMTQsImlhdCI6MTY1MzQ3NTcxNCwidXNlcklkIjoiNWFkZTI5Y2U0ZGQzZDcwNzdmZjI2MGEwZTVkNWZmMzAiLCJuYW1lIjoiengifQ.Lz5Xv8gr_o3E9dSOeowmdi1UtgeVOm8Ks-gs8C735tc';
let userId = '5ade29ce4dd3d7077ff260a0e5d5ff30';


function errMsg(title, message) {
  Notification.warning({
    title: title,
    message: message
  })
}

function startLoading() {
  loading = Loading.service({
    lock: true,
    text: '',
    background: 'rgba(0, 0, 0, 0)',
    spinner: 'el-icon-loading',
    customClass: 'jiazai'
  })
}

function endLoading() {
  loading.close()
}

let needLoadingRequestCount = 0
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

export function removeStorageFn() {
  localStorage.removeItem("authorization")
  localStorage.removeItem("hotelCode")
  localStorage.removeItem("userId")
  store.commit('authorization', '');
  store.commit('hotelCode', '');
  allFu.allFu.remove('authorization'); // crm去除登录重要标志
}

// axios.defaults.baseURL = '/apiAdmin'
// console.log(axios.defaults.baseURL,'/apiAdmin')
axios.defaults.timeout = 10000
axios.interceptors.request.use(config => {
  // console.log(config,'---config----')
  // 订单列表处，显示laoding操作导致一直回调mouseover函数，所以这个接口不显示loading
  if (config.url.indexOf("crm/hotel/getPrincipal") == -1) {
    showFullScreenLoading(); // 不展示加载了。
  }

  setTimeout(() => {
    tryHideFullScreenLoading()
  }, 8000)
  return config
}, err => {
  // console.log(err,'---error----')
  setTimeout(() => {
    tryHideFullScreenLoading()
  }, 8000)
  return Promise.resolve(err)
})

axios.interceptors.response.use(response => {
  tryHideFullScreenLoading()
  // console.log(response,'--response 拦截响应code---111')
  if (response) {
    switch (response.data.code) {
      case 6: //与后台约定登录失效的返回码,根据实际情况处理
        break
    }

  }
  return response
}, err => {
  // console.log(err,'拦截响应错误222',err.response.status)
  let status = +err.response.status;
  if (err.response.status !== 200) {
    if (status >= 500) {
      errMsg('错误', "服务器异常，请稍后重试!");
    }
    removeStorageFn();
    setTimeout(() => {
      tryHideFullScreenLoading()
    }, 200)
    // location.replace(isMobile); 临时注调
  } else {
    setTimeout(() => {
      tryHideFullScreenLoading()
    }, 10000)
    return Promise.resolve(err);
  }

})
let userLogin = "";
export const postRequest = (url, params, Func, isJson, Func1) => {
  request(url, params, 'post', Func, isJson, Func1)
}
//是否正在刷新标记
let isRefresh = false;
// 重试队列，每一项将是一个待执行的函数形式
let requests = [];
export const request = (url, params, method, Func, isJson, Func1) => {
  // console.log(url, params, method,'------------userId--------------------')
  // 测试网址 mock
  let baseUrl = "";
  baseUrl = base;
  // 保证返回的还是一个promise对象
  let jsonParams = {}
  if (method == 'post' || method == 'POST') {
    if (url.indexOf('webapi/material/add') != -1 || url.indexOf('webapi/file/upload') != -1) {
      jsonParams = params;
    } else {
      jsonParams = allFu.allFu.isProduct() ? allFu.allFu.encryption(params) : params;
    }
  } else {
    jsonParams = params;
  }

  // 测试不加密
  // jsonParams = params ;
  return axios({
    method: method,
    url: `${baseUrl}${url}`,
    data: jsonParams,
    headers: {
      'Content-Type': isJson === 1 ? 'application/json' : 'application/x-www-form-urlencoded',
      'authorization': allFu.allFu.get("authorization") ? allFu.allFu.get("authorization") : authorization,
      "userid": allFu.allFu.get("userId") ? allFu.allFu.get("userId") : userId,
      // 'staffRoleAuthMd5':'8fddf80d0c8a3d676346e6e47e8a1f69',   // 本地测试
      // 'visitorId':'041ba2d7cbdc517fadb886354d2abb5a'
    }
  }).then(data => {
    // console.log(data.data,'data----数据')
    let deckData = allFu.allFu.isProduct() ? allFu.allFu.decrypt(data.data, 'CKsH@Db00qONJo0b') : data.data;
    if (deckData.code === 0) {
      Func(deckData);
    } else if (deckData.code == 12) {
      errMsg('错误', "该手机号已经注册,请直接登录");
    } else if (deckData.code == 22) {
      // errMsg('错误',deckData.msg);
      errMsg('错误', '短信验证码有误，请重新输入');
      Func(deckData);
    } else if (deckData.code == 6) {
      removeStorageFn();
      MessageBox.confirm('请先登录', '提示', {
        closeOnClickModal: false,
        confirmButtonText: '确定',
        showCancelButton: false,
        showClose: false,
        type: 'warning',
      }).then(() => {
        removeStorageFn();
        location.replace(isMobile);
        // router.go(0);
      }).catch(() => {});
      // window.location.href = isMobile   // 临时关闭
      // router.replace({
      //   path: isMobile
      // })
    } else if (deckData.code == 8) {
      console.log(showOut, '-----走了几次-----')

      if (!showOut) {
        showOut = true;
        console.log('---弹窗几次----')
        MessageBox.confirm('长时间未操作，请重新登录', '提示', {
          closeOnClickModal: false,
          confirmButtonText: '确定',
          showCancelButton: false,
          showClose: false,
          type: 'warning',
        }).then(() => {
          removeStorageFn();
          location.replace(isMobile);
          // router.go(0);
        }).catch(() => {});
      } else {
        if (!allFu.allFu.get('authorization')) {
          removeStorageFn();
          location.replace(isMobile);
        }
      }




    }
    // else if(deckData.code == 29){
    //     console.log(multiDevice,'-----您的账号已在其他设备登录，请重新登录-----')

    //         if(!multiDevice){
    //             multiDevice = true ;
    //             console.log('---弹窗几次----')
    //             MessageBox.confirm('您的账号已在其他设备登录，请重新登录', '提示', {
    //               closeOnClickModal:false,
    //               confirmButtonText: '确定',
    //               showCancelButton:false,
    //               showClose:false,
    //               type: 'warning',
    //             }).then(() => {
    //               removeStorageFn();
    //               location.replace(isMobile);

    //               // router.go(0);
    //             }).catch(() => {});
    //         }else{
    //           if(!allFu.allFu.get('authorization')){
    //             removeStorageFn();
    //             location.replace(isMobile);
    //           }
    //         }



    // }
    else if (deckData.code == 810) {
      if (!multiDevice) {
        multiDevice = true;
        console.log('---弹窗几次----')
        MessageBox.confirm('当前权限已发生变化，请重新进入项目', '提示', {
          closeOnClickModal: false,
          confirmButtonText: '确定',
          showCancelButton: false,
          showClose: false,
          type: 'warning',
        }).then(() => {
          setTimeout(() => {
            multiDevice = false;
          }, 3000)
          console.log(router, '---- router -----');
          removeStorageFn();
          location.replace(isMobile);

        }).catch(() => {});
      }


    } else if (deckData.code == 4 || deckData.code == 5 || deckData.code == 507) {
      Func(deckData);
    } else if (deckData.code == 508) {
      errMsg('错误', '当前订单已过期');
      let href = returnGoUrl('order');
      window.location.replace(href, '_blank')
    } else if (deckData.code == 509) {
      errMsg('错误', '请勿重复操作该订单');
      let href = returnGoUrl('order');
      window.location.replace(href, '_blank')
    } else if (deckData.code == 30 || deckData.code == 806 || deckData.code == 18 || deckData.code == 27 || deckData.code == 19 || deckData.code == 20) {
      errMsg('错误', deckData.msg)
    } else if (deckData.code == 7 || deckData.code == 23 || deckData.code == 24 || deckData.code == 10) {
      Func(deckData);
      errMsg('错误', deckData.msg)
      removeStorageFn();
      location.replace(isMobile);
    } else if (deckData.code == 807) {
      if (!showPower) {
        showPower = true;
        errMsg('错误', "您已被禁止操作该项目,请联系项目负责人")
        removeStorageFn();
        location.replace(isMobile);
      }

    } else if (deckData.code == 808) {
      if (!showPower) {
        showPower = true;
        errMsg('错误', "您已无法管理该项目,请联系项目负责人")
        removeStorageFn();
        location.replace(isMobile);
      }
    } else if (deckData.code == 511) {
      if (!multiDevice) {
        multiDevice = true;
        console.log('---弹窗几次----')
        MessageBox.confirm('该笔订单状态已更新，确认刷新订单状态', '提示', {
          closeOnClickModal: false,
          confirmButtonText: '确定',
          showCancelButton: false,
          showClose: false,
          type: 'warning',
        }).then(() => {
          setTimeout(() => {
            multiDevice = false;
          }, 3000)
          let href = returnGoUrl('order');
          window.location.replace(href, '_blank')

        }).catch(() => {});
      }


    } else if (deckData.code == 512) {
      if (!multiDevice) {
        multiDevice = true;
        console.log('---弹窗几次----')
        MessageBox.confirm('代理人员已为该项目创建订单，详情可联系代理', '提示', {
          closeOnClickModal: false,
          confirmButtonText: '确定',
          showCancelButton: false,
          showClose: false,
          type: 'warning',
        }).then(() => {
          setTimeout(() => {
            multiDevice = false;
          }, 300)
          let href = returnGoUrl('order');
          window.location.replace(href, '_blank')

        }).catch(() => {});
      }


    } else if (deckData.code == 25) {
      Func(deckData);
      errMsg('错误', deckData.msg);
    } else if (deckData.code == 513) {
      Func(deckData, deckData.msg);
    } else {
      /* 
       @params：code自定义状态码，每个函数可能不一样
       @params：message:后台提示信息
      */
      // Notification.error({
      //   title: '错误',
      //   message: data.data.msg
      // })
      Func(deckData, deckData.msg);
      setTimeout(() => {
        tryHideFullScreenLoading()
      }, 10000)
    }
  })
}
export const putRequest = (url, params, Func, isJson) => {
  request(url, params, 'put', Func, isJson)
}
export const deleteRequest = (url, params, Func, isJson) => {
  request(url, params, 'delete', Func, isJson)
}
export const getRequest = (url, params, Func, isJson, Func1) => {
  request(url, params, 'get', Func, isJson, Func1)
}
export const uploadFileRequest = (url, params, fun) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
      'authorization': allFu.allFu.get("authorization") ? allFu.allFu.get("authorization") : authorization,
      "userid": allFu.allFu.get("userId") ? allFu.allFu.get("userId") : userId
      // 'staffRoleAuthMd5':localStorage.getItem("staffRoleAuthMd5")
    }
  }).then(data => {
    let deckData = allFu.allFu.isProduct() ? allFu.allFu.decrypt(data.data, 'CKsH@Db00qONJo0b') : data.data;
    if (deckData.code === 0) {
      fun(deckData);
    } else if (deckData.code == 12) {
      errMsg('错误', "该手机号已经注册,请直接登录")
    } else if (deckData.code == 22) {
      fun(deckData);
      errMsg('错误', deckData.msg)
    } else if (data.data.code == 6) {
      errMsg('错误', deckData.msg)
      removeStorageFn();
      location.replace(isMobile);
    } else if (deckData.code == 7 || deckData.code == 10) {
      errMsg('错误', deckData.msg)
      removeStorageFn();
      location.replace(isMobile);
    } else {
      fun(deckData, deckData.msg);
    }
  }).catch(err => {
    console.warn("FBI WARNING:" + err)
  })
}
//后台直接返回的是文件  
export const downFileRequest = (url, params, fun) => {
  return axios({
    method: 'get',
    url: `${base}${url}`,
    params: params, //get请求传递的参数是params，`params` 是即将与请求一起发送的 URL 参数
    // 必须是一个无格式对象(plain object)或 URLSearchParams 对象,`data`是作为请求主体被发送的数据, 只适用于这些请求方法 'PUT', 'POST', 和 'PATCH'
    responseType: 'blob', //相应类型一定要设置为bolb
    headers: {
      'Content-Type': 'multipart/form-data',
      'authorization': userLogin,
      'token': localStorage.getItem('token'),
      "clientAppId": "1143052791856254977", //这个是写死的
    }
  }).then(data => {
    let blob = new Blob([data.data], {
      type: "application/vnd.ms-excel"
    }); // res就是接口返回的文件流了
    let objectUrl = URL.createObjectURL(blob);
    window.location.href = objectrl;
  }).catch(err => {
    console.warn("FBI WARNING:" + err)
  })
}



// WEBPACK FOOTER //
// ./src/api/http.js